import { createAsyncThunk } from "@reduxjs/toolkit";
import { notificationFail, notificationSuccess } from "../slices/notificationSlice";
import { tenantList, setLoader, tenantDropDownList, setLoaderEvent } from "../slices/tenantSlice";
import { API, graphqlOperation } from 'aws-amplify';
import { storeRecentSubstanceHistoryMutation, createTenantMutation, changeTenantStatusMutation, deleteTenantMutation, recoverTenantMutation, updateUserConfigMutation, enableMFAMutation, sendContactSupportMutation, updateUserDefaultViewMutation, updateTenantInfoMutation, storeUserLocationDetailsMutation } from '../../graphql/mutations';
import { getTenantsQuery, getTenantsDropDownQuery } from '../../graphql/queries';
import { ChangeServiceRequest, addLogToAws } from "./commonThunk";
import { otp_status_mfa } from "../slices/profileSlice";
import { getLocationLists } from "./locationThunk";
import { devApi, prodApi, qaApi } from "../../aws-export";
import { getUserDetailsMutation } from "../../graphql/mutations";
import { setUserData } from "../slices/authSlice";
import { RootState } from "../store";
import { LocationListType, userLocationInfoType } from "../../components/common/LocationSelector";

export const getTenantList = createAsyncThunk("tenantList", async (_request: any, { dispatch }) => {

  try {
    dispatch(setLoader(true))
    const postData = await API.graphql(graphqlOperation(getTenantsQuery, _request)) as { data: any, errors: any[] }
    dispatch(tenantList(postData.data));
    let logData = {
      userData: "",
      apiName: "getTenantList",
      request: JSON.stringify(_request),
      response: JSON.stringify(postData.data),
      'type': "frontend"
    }
    dispatch(addLogToAws(logData))
  }
  catch (error) {
    dispatch(notificationFail("Something went wrong"))
    let logData = {
      userData: "",
      apiName: "getTenantList",
      request: JSON.stringify(_request),
      response: JSON.stringify(error),
      type: "frontend"
    }
    dispatch(addLogToAws(logData))
  }
  dispatch(setLoader(false))
});

export const getTenantDropDownList = createAsyncThunk("tenantDropDownList", async (_request: any, { dispatch }) => {

  try {
    dispatch(setLoader(true))
    dispatch(setLoaderEvent(true))
    const postData = await API.graphql(graphqlOperation(getTenantsDropDownQuery, { "all": 'true' })) as { data: any, errors: any[] }
    dispatch(tenantDropDownList(postData.data));
    if (postData?.data?.getTenants?.tenants && _request?.location_page_data) {
      dispatch(getLocationLists(_request?.location_page_data));
    }
  }
  catch {
    dispatch(notificationFail("Something went wrong"))
  }
  dispatch(setLoader(false))
  dispatch(setLoaderEvent(false))
});

export const createNewTenant = createAsyncThunk("createNewTenant", async (_request: any, { dispatch }) => {
  dispatch(setLoader(true))

  try {

    const data = await API.graphql({
      ...graphqlOperation(createTenantMutation, { tenant: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };

    if (data.data.createTenant.success === 'false') {
      dispatch(notificationFail(data.data.createTenant.message))
    } else {
      dispatch(notificationSuccess(data.data.createTenant.message));
    }
    if (_request.callback) {
      _request.callback(data.data.createTenant.success)
    }
  } catch {
    dispatch(notificationFail("Found Error While creating Tenant"))
  }
  dispatch(setLoader(false))

});


export const changeTenantStatus = createAsyncThunk("changeTenantStatus", async (_request: any, { dispatch }) => {

  try {

    const data = await API.graphql({
      ...graphqlOperation(changeTenantStatusMutation, { changeStatus: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };

    if (data.data.changeTenantStatus.success === 'true') {
      dispatch(notificationSuccess(_request.request.status ? "Tenant Actived successfully" : "Tenant Freeze successfully"));
    } else {
      dispatch(notificationFail("Something went wrong"));
    }

    if (_request.callback) {
      _request.callback()
    }

  } catch {
    dispatch(notificationFail("Something went wrong"))
  }

});

export const deleteSingleTenant = createAsyncThunk("changeTenantStatus", async (_request: any, { dispatch }) => {

  try {
    await API.graphql({
      ...graphqlOperation(deleteTenantMutation, { deleteTenant: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });

    dispatch(notificationSuccess("Tenant Deleted Successfully"));
    const items = JSON.parse(localStorage.getItem('tenantId') || '{}');
    if (items.tenantId === _request.request.tenantId) {
      localStorage.removeItem("tenantId");
    }
    if (_request.callback) {
      _request.callback()
    }

  } catch {
    dispatch(notificationFail("Something went wrong"))
  }

});


export const recoverDeletedTenant = createAsyncThunk("recoverDeletedTenant", async (_request: any, { dispatch }) => {

  try {
    await API.graphql({
      ...graphqlOperation(recoverTenantMutation, { recoverId: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });

    dispatch(notificationSuccess("Tenant Recovered Successfully"));
    const items = JSON.parse(localStorage.getItem('tenantId') || '{}');
    if (items.tenantId === _request.request.tenantId) {
      localStorage.removeItem("tenantId");
    }
    if (_request.callback) {
      _request.callback()
    }

  } catch {
    dispatch(notificationFail("Something went wrong"))
  }

});

export const updateUserDetailsThunk = createAsyncThunk("updateUser", async (_request: any, { dispatch }) => {

  try {
    await API.graphql({
      ...graphqlOperation(updateUserConfigMutation, { userConfig: _request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });

    dispatch(notificationSuccess("User Details Updated Successfully"));

  } catch {
    dispatch(notificationFail("Something went wrong"))
  }

});

export const enableMFAThunk = createAsyncThunk("enableMFAThunk", async (_request: any, { dispatch }) => {
  try {
    const data = await API.graphql({
      ...graphqlOperation(enableMFAMutation, { userEnableMFA: _request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };
    if (data.data.userEnableMFA.success == 'true') {
      dispatch(otp_status_mfa(false))
      dispatch(notificationSuccess(_request.enableMFA ? `MFA enabled successfully` : `MFA disabled successfully`));
    } else {
      dispatch(notificationFail("MFA not enable, Please update phone number"));
    }
  } catch (err) {
    dispatch(notificationFail("Something went wrong"))
  }
});
export const sendContactSupportThunk = createAsyncThunk("sendContactSupport", async (_request: any, { dispatch }) => {
  try {

    const data = await API.graphql({
      ...graphqlOperation(sendContactSupportMutation, { contactSupport: _request.request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: any, errors: any[] };
    if (data.data.contactSupportEmail.success === 'true') {
      dispatch(notificationSuccess(data.data.contactSupportEmail.message));
    } else {
      dispatch(notificationFail(data.data.contactSupportEmail.message));
    }
  } catch (err) {
    dispatch(notificationFail("Something went wrong"))
  }
});

export const updateUserDefaultView = createAsyncThunk("updateUserDefaultView", async (_request: any, { dispatch }) => {
  const loginwithtype = localStorage.getItem("loginwith") || "";
  try {

    dispatch(
      ChangeServiceRequest({
        request:
          loginwithtype === "qa"
            ? qaApi
            : loginwithtype === "prod"
              ? prodApi
              : devApi,
      })
    );

    await API.graphql({
      ...graphqlOperation(updateUserDefaultViewMutation, _request),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });

    //Update dashboard_view to userData reducer state
    dispatch(
      setUserData({
        ..._request.user,
        dashboard_view: _request.dashboard_view,
      })
    );

    // dispatch(notificationSuccess("User Details Updated Successfully"));

  } catch {
    dispatch(notificationFail("Something went wrong in updateUserDefaultView"))
  }

});


export const updateTenantInfoThunk = createAsyncThunk("updateTenantInfoThunk", async (_request: any, { dispatch }) => {
  try {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    dispatch(
      ChangeServiceRequest({
        request:
          loginwithtype === "qa"
            ? qaApi
            : loginwithtype === "prod"
              ? prodApi
              : devApi,
      })
    );
    await API.graphql({
      ...graphqlOperation(updateTenantInfoMutation, _request),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });

    //Update tenant_info to userData reducer state
    dispatch(
      setUserData({
        ..._request.user,
        tenant_info: _request.tenant_info,
      })
    );
  } catch {
    dispatch(notificationFail("Something went wrong in updateTenantInfoThunk"))
  }

});

export const storeQuerySubstanceHistoryThunk = createAsyncThunk("storeQuerySubstanceHistoryThunk", async (_request: { username: string, querySubstanceHistory?: string; substanceHistory?: string; scheduleReportSubstanceHistory?: string; timeseriesSubstanceHistory?: string; generateNotificationSubstanceHistory?: string; }, { dispatch, getState }) => {
  try {
    const userData = (getState() as RootState).authReducer?.userData;
    const loginwithtype = localStorage.getItem("loginwith") || "";
    dispatch(
      ChangeServiceRequest({ request: loginwithtype === "qa" ? qaApi : loginwithtype === "prod" ? prodApi : devApi, })
    );
    const response = await API.graphql({
      ...graphqlOperation(storeRecentSubstanceHistoryMutation, { recentSubstanceHistoryRequest: _request }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: { storeRecentSubstanceHistory: { success: string; message: string } } };
    if (response?.data?.storeRecentSubstanceHistory?.success === "true") {
      dispatch(
        setUserData({
          ...userData,
          ...(_request?.querySubstanceHistory ? { querySubstanceHistory: _request.querySubstanceHistory } : {}),
          ...(_request?.substanceHistory ? { substanceHistory: _request.substanceHistory } : {}),
          ...(_request?.scheduleReportSubstanceHistory ? { scheduleReportSubstanceHistory: _request.scheduleReportSubstanceHistory } : {}),
          ...(_request?.timeseriesSubstanceHistory ? { timeseriesSubstanceHistory: _request.timeseriesSubstanceHistory } : {}),
          ...(_request?.generateNotificationSubstanceHistory ? { querySubstanceHistory: _request.generateNotificationSubstanceHistory } : {}),
        })
      );
    }
  } catch (err) {
    console.error(err);
  }
});
export const storeUserLocationDetailsMutationThunk = createAsyncThunk("storeUserLocationDetailsMutationThunk", async (_request: { username: string, location_info: LocationInfoType; }, { dispatch, getState }) => {
  try {
    const userData = (getState() as RootState).authReducer?.userData;
    const locations = (getState() as RootState).locationSlice?.locationList?.getLocations || [];
    const loginwithtype = localStorage.getItem("loginwith") || "";
    dispatch(
      ChangeServiceRequest({ request: loginwithtype === "qa" ? qaApi : loginwithtype === "prod" ? prodApi : devApi, })
    );
    const locationData = JSON.parse(userData?.location_info || "{}") as userLocationInfoType;
    let requestData = {
      system: _request?.location_info?.system || locationData?.system || "",
      facility: _request?.location_info?.facility || locationData?.facility || "",
      floor: _request?.location_info?.floor || locationData?.floor || "",
      room: _request?.location_info?.room || locationData?.room || "",
      device: _request?.location_info?.device || locationData?.device || "",
    }
    if (_request?.location_info?.system && _request?.location_info?.system !== locationData?.system) {
      requestData = {
        ...requestData,
        system: _request?.location_info?.system || "",
        facility: "",
        floor: "",
        room: "",
        device: "",
      }
    }
    if (_request?.location_info?.facility && _request?.location_info?.facility !== locationData?.facility) {
      const systemKey = locations?.find((value: any) => value?.key === _request?.location_info?.facility)?.parentKey;
      requestData = {
        ...requestData,
        system: systemKey,
        facility: _request?.location_info?.facility || "",
        floor: "",
        room: "",
        device: "",
      }
    }
    if (_request?.location_info?.floor && _request?.location_info?.floor !== locationData?.floor) {
      const floor = locations?.find((value: any) => value?.key === _request?.location_info?.floor);
      const facility = locations?.find((value: any) => value?.key === floor?.parentKey);
      requestData = {
        ...requestData,
        system: facility?.parentKey,
        facility: facility?.key,
        floor: _request?.location_info?.floor || "",
        room: "",
        device: "",
      }
    }
    if (_request?.location_info?.room && _request?.location_info?.room !== locationData?.room) {
      // console.log(_request?.location_info?.isFacilityGroup, locations, 'hello');
      let room: LocationListType | undefined;
      let floor: LocationListType | undefined;
      let facility: LocationListType | undefined;
      if (_request?.location_info?.isFacilityGroup) {
        room = locations?.find((value: any) => value?.key === _request?.location_info?.room);
        facility = locations?.find((value: any) => value?.key === room?.facility_unit_key);
        floor = undefined;
      } else {
        room = locations?.find((value: any) => value?.key === _request?.location_info?.room);
        if (_request?.location_info?.isUnit) {
          floor = locations?.find((value: any) => value?.key === room?.unit_key);
        } else {
          floor = locations?.find((value: any) => value?.key === room?.parentKey);
        }
        facility = locations?.find((value: any) => value?.key === floor?.parentKey);
      }
      requestData = {
        ...requestData,
        system: facility?.parentKey || "",
        facility: facility?.key || "",
        floor: floor?.key || "",
        room: _request?.location_info?.room || "",
        device: "",
      }
    }
    // if (_request?.location_info?.device !== locationData?.device) {
    //   requestData = {
    //     ...requestData,
    //     device: _request?.location_info?.device || "",
    //   }
    // }
    // console.log(requestData, _request, locations, 'storeUserLocationDetailsMutationThunk before called');
    if (userData?.location_info === JSON.stringify(requestData)) return;
    // console.log(requestData, _request, locations, 'storeUserLocationDetailsMutationThunk called');
    const response = await API.graphql({
      ...graphqlOperation(storeUserLocationDetailsMutation, { storeUserLocationDetailRequest: { ..._request, location_info: JSON.stringify(requestData) } }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    }) as { data: { storeUserLocationDetails: { success: string; message: string } } };
    if (response?.data?.storeUserLocationDetails?.success === "true") {
      dispatch(
        setUserData({
          ...userData,
          ...(_request?.location_info ? { location_info: JSON.stringify(requestData) } : {}),
        })
      );
    }
  } catch (err) {
    console.error(err);
  }
});
type LocationInfoType = {
  system?: string;
  facility?: string;
  floor?: string;
  room?: string;
  device?: string
  isFacilityGroup?: boolean;
  isUnit?: boolean;
}



